module.exports = __webpack_public_path__ + "img/test1.56a9fae5.jpg";